


























































































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { DepositAccountSettingsModule } from '@/store/Accounts/DepositAccountSettingsModule';
import Wallet from '@/models/Accounts/DepositAccounts/Wallets/Wallet';
import DepositAccountSummary from "@/models/Accounts/DepositAccounts/DepositAccountSummary";
import WalletDetailsEditDialog from '@/components/Accounts/DepositAccounts/Wallets/WalletDetailsEditDialog.vue';
import WalletManuallyPostInterestDialog from '@/components/Accounts/DepositAccounts/Wallets/WalletManuallyPostInterestDialog.vue';
import WalletState from '@/components/Accounts/DepositAccounts/Wallets/WalletState.vue';
import PermissionUtils from '@/lib/permissionUtils';
import FeatureToggleCode from "@/models/Settings/Institutions/FeatureToggleCode";
import ProductSubType from '@/models/Products/ProductSubType';

@Component({ name: 'WalletOverview', components: { WalletDetailsEditDialog, WalletManuallyPostInterestDialog, WalletState } })
export default class extends SaascadaVue {

    PermissionUtils = PermissionUtils;
    FeatureToggleCode = FeatureToggleCode;

    @Prop({required: true})
    wallet: Wallet;

    @Prop({required: true})
    account: DepositAccountSummary;

    get allowManuallyPostInterest() {
        // Only allow manually posting interest if:
        // - For fixed term products, check that there is a non zero amount of accrued interest
        // - For other products with the default wallet, check if overdraft interest settings are allowed but have been disabled
        // - For other products with the a secondary wallet, check that there is a non zero amount of accrued interest

        const walletHasAccrualAmount = parseFloat(this.wallet.accrualAmount.amount) > 0;

        if (this.account.productSubType === ProductSubType.DepositFixedTerm) {
            return walletHasAccrualAmount;
        }
        else {
            // For the default wallet
            if (this.wallet.default) {
                const hasOverdraftSettings = DepositAccountSettingsModule.settings.depositOverdraftSettings;
                const overdraftIsDisabled = DepositAccountSettingsModule.settings.depositOverdraftSettings ? !DepositAccountSettingsModule.settings.depositOverdraftSettings.enabled : true;
                return walletHasAccrualAmount && hasOverdraftSettings && overdraftIsDisabled;
            }
            // For any secondary wallets
            else {
                return walletHasAccrualAmount;
            }
        }
    }
}
